export const MAX_TRIAL_INSTRUMENTS = 35;


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/syncit/constants.ts